var _circle, _path, _line, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZenModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#F2FAF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1963 14C24.1963 19.6313 19.6312 24.1964 13.9999 24.1964C8.36855 24.1964 3.80345 19.6313 3.80345 14C3.80345 8.36867 8.36855 3.80357 13.9999 3.80357C19.6312 3.80357 24.1963 8.36867 24.1963 14Z",
    fill: "white",
    stroke: "#344868",
    strokeWidth: 0.607143
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.54761,
    y1: 6.57739,
    x2: 21.3969,
    y2: 21.4266,
    stroke: "#344868",
    strokeWidth: 1.19531
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_23915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1213 9.43372C17.0063 8.48747 15.5588 7.87497 14 7.87497C10.6038 7.87497 7.875 10.6037 7.875 14H8.98875C8.98875 11.2162 11.2163 8.98872 14 8.98872C15.2813 8.98872 16.45 9.43497 17.285 10.2137L16.3388 11.105L19.68 11.7175L19.1788 8.37622L18.1213 9.43372ZM9.99125 18.6212C11.1038 19.5687 12.4963 20.125 14 20.125C17.3963 20.125 20.125 17.3962 20.125 14H19.0113C19.0113 16.7837 16.7838 19.0112 14 19.0112C12.775 19.0112 11.6613 18.565 10.8263 17.8975L11.885 16.895L8.54375 16.2825L9.045 19.6237L9.99125 18.6212Z",
    fill: "#344868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_23915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenModeIcon);
export default __webpack_public_path__ + "static/media/zen-mode-icon.4f1ed7fb.svg";
export { ForwardRef as ReactComponent };